export default __webpack_public_path__ + "static/20211202_150512-163a6688ba2315ed4825a05c3dea4d13.jpeg";